function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
import PropTypes from "prop-types";
var SvgVisa = function SvgVisa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16z",
    fill: "#0054A4"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "Visa_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#Visa_svg__a)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.203 19.427l1.18-7.3h1.884l-1.179 7.3h-1.885zM20.925 12.306A4.67 4.67 0 0019.238 12c-1.864 0-3.176.99-3.187 2.41-.012 1.049.936 1.634 1.651 1.982.735.358.981.587.978.906-.005.49-.586.713-1.128.713-.754 0-1.155-.11-1.775-.383l-.243-.116-.263 1.634c.439.204 1.254.38 2.1.39 1.98 0 3.267-.98 3.282-2.494.007-.832-.495-1.463-1.583-1.984-.659-.338-1.063-.562-1.058-.905 0-.303.341-.628 1.08-.628a3.315 3.315 0 011.41.28l.17.084.255-1.583zM23.435 16.84c.157-.42.751-2.041.751-2.041-.01.019.156-.423.25-.697l.128.63s.362 1.742.436 2.107h-1.565zm2.326-4.706h-1.457c-.452 0-.79.13-.988.606l-2.8 6.69h1.98s.323-.9.397-1.098l2.414.004c.057.255.23 1.094.23 1.094h1.75l-1.526-7.296zM10.622 12.133L8.777 17.11 8.58 16.1c-.344-1.166-1.414-2.43-2.611-3.063l1.687 6.385 1.995-.001 2.968-7.287h-1.997z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.065 12.128h-3.04L4 12.28c2.365.604 3.93 2.064 4.58 3.818l-.66-3.354c-.115-.462-.446-.6-.855-.616z",
    fill: "#F39C12"
  })));
};
SvgVisa.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgVisa.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgVisa;